
<h2 *ngIf="!editModeAdmin" class="sectionTitle">Circular Request</h2>
<div [class.read-only-content]="formMode == 3">
    <div *ngIf="(formMode == 2 || formMode == 3) && !isFormValid && !isCloneComponent">
        <app-request-details [baseRequest]="rebateRequestLoaded.BaseRequest"></app-request-details>
        <div *ngIf="rebateRequestLoaded.RebateFileNumber != null" class="bs-callout bs-callout-info">
            <div class="form-container">
                <div class="form-group">
                    <h4>Rebate File Number</h4>
                    <p>[{{rebateRequestLoaded.RebateFileNumber}}]</p>
                </div>
                <div class="form-group" *ngIf="!currentUser?.IsAdmin && !insideCancelationComponents &&
                showPDF" >
                    <h4>SCA Replay</h4>
                    <div>
                        <a class="export-link" href="#" (click)="exportAgentPdf($event)">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                aria-hidden="true" role="img" width="1.25em" height="1.25em"
                                preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
                                <path
                                    d="M13.156 9.211c-.213-.21-.686-.321-1.406-.331a11.754 11.754 0 0 0-1.69.124c-.276-.159-.561-.333-.784-.542c-.601-.561-1.103-1.34-1.415-2.197c.02-.08.038-.15.054-.222c0 0 .339-1.923.249-2.573a.73.73 0 0 0-.044-.184l-.029-.076c-.092-.212-.273-.437-.556-.425l-.171-.005c-.316 0-.573.161-.64.403c-.205.757.007 1.889.39 3.355l-.098.239c-.275.67-.619 1.345-.923 1.94l-.04.077c-.32.626-.61 1.157-.873 1.607l-.271.144c-.02.01-.485.257-.594.323c-.926.553-1.539 1.18-1.641 1.678c-.032.159-.008.362.156.456l.263.132a.792.792 0 0 0 .357.086c.659 0 1.425-.821 2.48-2.662a24.79 24.79 0 0 1 3.819-.908c.926.521 2.065.883 2.783.883c.128 0 .238-.012.327-.036a.558.558 0 0 0 .325-.222c.139-.21.168-.499.13-.795a.531.531 0 0 0-.157-.271zM3.307 12.72c.12-.329.596-.979 1.3-1.556c.044-.036.153-.138.253-.233c-.736 1.174-1.229 1.642-1.553 1.788zm4.169-9.6c.212 0 .333.534.343 1.035s-.107.853-.252 1.113c-.12-.385-.179-.992-.179-1.389c0 0-.009-.759.088-.759zM6.232 9.961c.148-.264.301-.543.458-.839c.383-.724.624-1.29.804-1.755a5.813 5.813 0 0 0 1.328 1.649c.065.055.135.111.207.166c-1.066.211-1.987.467-2.798.779zm6.72-.06c-.065.041-.251.064-.37.064c-.386 0-.864-.176-1.533-.464c.257-.019.493-.029.705-.029c.387 0 .502-.002.88.095s.383.293.318.333z"
                                    fill="currentColor" />
                                <path
                                    d="M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 0 1-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 0 0 .5.5H14v9.75z"
                                    fill="currentColor" />
                            </svg>
                            <span>Print as PDF</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="currentUser?.IsAdmin && formMode != 1 && !isFormValid" class="bs-callout bs-callout-info">
        <h4>Internal status</h4>
        <p>{{rebateRequestLoaded?.Status?.StatusEN}}</p>
    </div>
    <div *ngIf="rebateRequestLoaded.IsSubRequest && !isFormValid" class="bs-callout bs-callout-info">
        <h4>Sub Request</h4>
        <p>Sub Request to Rebate Request No. <a
                (click)="navigateToParentRequestDetails()">[{{rebateRequestLoaded.ParentRequestNumber}}]</a></p>
        <P *ngIf="ParentCreationDateForSubRequest">Created [{{ParentCreationDateForSubRequest | date: 'dd/MM/yyyy
            H:mm:ss '}} {{'GMT+2'}}] </P>
    </div>
    <div *ngIf="isRequireModificationNotesExist" class="bs-callout bs-callout-info">
        <h4>Required Modifications Notes</h4>
        <p>{{requireModificationNotes}}</p>
    </div>
    <div *ngIf="isRejectionReasonNotesExist" class="bs-callout bs-callout-danger">
        <h4>Rejection Reason</h4>
        <p>{{requireModificationNotes}}</p>
    </div>
    <div *ngIf="!isFormValid" >
        <div class="bs-callout bs-callout-info" *ngIf="!insideCancelationComponents && formMode==3 && !currentUser?.IsAdmin
        && ((rebateRequestLoaded.InternalStatusId == serviceStatus.Circulars_AcceptedByRequestor || rebateRequestLoaded.InternalStatusId == serviceStatus.Circulars_ShipPassed)
        || (rebateRequestLoaded.ExternalStatusId == serviceStatus.Circulars_AcceptedByRequestor || rebateRequestLoaded.ExternalStatusId == serviceStatus.Circulars_ShipPassed)
        || (rebateRequestLoaded.CanClone && showClone))">
            <h4 >
                {{ 'FRONT_USER.ACTION_TO_BE_TAKEN' | translate }}
            </h4>
            <div class="dropdown">
                <button id="request-action-menu" type="button" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    {{ 'FRONT_USER.TAKE_ACTION' | translate }}
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu" aria-labelledby="request-action-menu">
                    <li  *ngIf="rebateRequestLoaded.CanClone && showClone">
                        <button type="button" class="" (click)="navigateToCloneRequest()">Clone Request</button>
                    </li>
                    <li *ngIf="formMode==3 &&
                    !currentUser?.IsAdmin && !insideCancelationComponents &&
                     (rebateRequestLoaded.InternalStatusId == serviceStatus.Circulars_AcceptedByRequestor || rebateRequestLoaded.InternalStatusId == serviceStatus.Circulars_ShipPassed || rebateRequestLoaded.ExternalStatusId == serviceStatus.Circulars_AcceptedByRequestor || rebateRequestLoaded.ExternalStatusId == serviceStatus.Circulars_ShipPassed)
                     ">
                        <button type="button" class="" (click)="cancelRequest()">{{"ADMIN_USER.CIRCULARS.CANCEL.MARK_AS_CANCELED" | translate}}</button>
                    </li>
                </ul>
            </div>

    </div>
        <!-- Form -->
        <form name="circularRequestForm" [formGroup]="circularRequestForm">
            <tabset #rebateRequestTabs>
                <!-- Step One -->
                <tab heading="Step One">
                    <div class="form-container" formGroupName="TabOne" #tabOne>
                        <!-- Requester Info. Section -->
                        <div class="form-section">
                            <h4 class="section-title">Requester Information</h4>
                            <!-- Email -->
                            <div class="form-group">
                                <label for="lblEmail">Email</label>
                                <!-- Read Only -->
                                <label class="form-control" name="Email" id="lblEmail">{{currentUserEmail}}</label>
                            </div>
                            <!-- Operator Name -->
                            <div class="form-group">
                                <label for="txtOperatorName">Operator Name</label>
                                <input type="text" formControlName="OperatorName" name="OperatorName"
                                    id="txtOperatorName" class="form-control text-uppercase" />
                                <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['OperatorName']?.invalid"
                                    class="red">
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['OperatorName']?.errors?.pattern">Please
                                        Enter a Valid Name</span>
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['OperatorName']?.errors?.maxlength">This
                                        Field can be at most 200 characters</span>
                                </div>
                            </div>
                            <!-- Operator Email -->
                            <div class="form-group">
                                <label for="txtOperatorEmail">Operator Email</label>
                                <input type="email" formControlName="OperatorEmail" name="OperatorEmail"
                                    id="txtOperatorEmail" class="form-control" />
                                <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['OperatorEmail']?.invalid"
                                    class="red">
                                    <!-- <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['OperatorEmail']?.errors?.email">Please Enter a Valid Email Format</span> -->
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['OperatorEmail']?.errors?.pattern">Please
                                        Enter a Valid Email Format</span>
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['OperatorEmail']?.errors?.maxlength">This
                                        Field can be at most 50 characters</span>
                                </div>
                            </div>
                        </div>
                        <!-- Vessel’s Particulars Section -->
                        <div class="form-section">
                            <h4 class="section-title">Vessel’s Particulars</h4>
                            <!-- Vessel Name -->
                            <div class="form-group">
                                <label for="txtVesselName">Vessel Name</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <input type="text" formControlName="VesselName" name="VesselName" id="txtVesselName"
                                    class="form-control text-uppercase" />
                                <div *ngIf="isTabOneSubmitted &&
                                    circularRequestForm?.controls['TabOne']?.controls['VesselName']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['VesselName']?.errors?.required">This
                                        Field is Required</span>
                                </div>
                                <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['VesselName']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['VesselName']?.errors?.pattern">Please
                                        Enter a Valid Vessel Name</span>
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['VesselName']?.errors?.maxlength">This
                                        Field can be at most 200 characters</span>
                                </div>
                            </div>
                            <!-- Vessel Type -->
                            <div class="form-group">
                                <label for="ddlVesselTypeId">Vessel Type</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <select formControlName="VesselTypeId" class="form-control" id="ddlVesselTypeId"
                                    name="VesselType" (change)="onVesseTypeChange($event.target.value)">
                                    <option value="" selected>Choose</option>
                                    <option *ngFor="let vesselType of vesselCircularsTypes"
                                        [value]="vesselType?.VesselTypeId">
                                        {{vesselType?.NameEN}}
                                    </option>
                                </select>
                                <div *ngIf="isTabOneSubmitted &&
                                    circularRequestForm?.controls['TabOne']?.controls['VesselTypeId']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['VesselTypeId']?.errors?.required">This
                                        Field is Required</span>
                                </div>
                            </div>

                            <!-- Ex Name(s) -->
                            <div class="form-group">
                                <label for="txtExNames">Ex Name(s)</label>
                                <input type="text" formControlName="ExNames" name="ExNames" id="txtExNames"
                                    class="form-control" />
                            </div>
                            <div class="form-group">
                                <label for="dpYearBuilt">Year Built</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <input #yearBuiltDatepicker="bsDatepicker" bsDatepicker formControlName="YearBuilt"
                                    [bsConfig]="{dateInputFormat: 'YYYY', minMode: hour, maxDate: yearBuiltMaxDate}"
                                    autocomplete="off" [minDate]='null' (onShown)="onOpenYearBuiltCalendar($event)"
                                    id="dpYearBuilt" class="form-control" name="YearBuilt">
                                <div *ngIf="isTabOneSubmitted &&
                                    circularRequestForm?.controls['TabOne']?.controls['YearBuilt']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['YearBuilt']?.errors?.required">This
                                        Field is Required</span>
                                </div>
                            </div>

                        </div>
                        <!-- Additional Info. Section -->
                        <div class="form-section">
                            <h4 class="section-title">Additional Information</h4>
                            <!-- Call Sign -->
                            <div class="form-group">
                                <label for="txtCallSign">Call Sign</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <input type="text" formControlName="CallSign" name="CallSign" id="txtCallSign"
                                    class="form-control text-uppercase" />
                                <div *ngIf="isTabOneSubmitted &&
                                    circularRequestForm?.controls['TabOne']?.controls['CallSign']?.invalid" class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['CallSign']?.errors?.required">This
                                        Field is Required</span>
                                </div>
                                <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['CallSign']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['CallSign']?.errors?.pattern">Call
                                        Sign allow English Letters and Numbers Only</span>
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['CallSign']?.errors?.maxlength">This
                                        Field can be at most 200 characters</span>
                                </div>
                            </div>
                            <!-- IMO No. -->
                            <div class="form-group">
                                <label for="txtIMONo">IMO Number</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <div class="input-group">
                                    <span class="input-group-addon">IMO</span>
                                    <!-- <input type="text" formControlName="IMONo" name="IMONo" id="txtIMONo" maxlength="7" class="form-control" (blur)="onIMOBlur()" /> -->
                                    <input type="text" formControlName="IMONo" name="IMONo" id="txtIMONo" maxlength="9"
                                        class="form-control" (input) ="onImoChange($event.target.value)" />
                                </div>
                                <div *ngIf="showImoWarning" style="color:darkgoldenrod;font-size:14px;">Rebate file No.
                                    {{reltatedFileNo}} needs to be closed first to process your new request</div>
                                <div *ngIf="isTabOneSubmitted &&
                                    circularRequestForm?.controls['TabOne']?.controls['IMONo']?.invalid" class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['IMONo']?.errors?.required">This
                                        Field is Required</span>
                                </div>
                                <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['IMONo']?.invalid"
                                    class="red">
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['IMONo']?.errors?.pattern">IMO
                                        Number must be (7 to 9) digits</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="txtSCNT">SCID</label>

                                <input type="text" formControlName="SCID" name="SCID" id="txtSCID"
                                    class="form-control" />

                                <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['SCID']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['SCID']?.errors?.pattern">SCID
                                        must be digits</span>
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['SCID']?.errors?.maxlength">This
                                        Field can be at most 50 characters</span>
                                </div>
                            </div>
                            <!-- DWT -->
                            <div class="form-group">
                                <label for="txtDWT">DWT</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <input type="text" formControlName="DWT" name="DWT" id="txtDWT" maxlength="6"
                                    class="form-control" />
                                <div *ngIf="isTabOneSubmitted &&
                                    circularRequestForm?.controls['TabOne']?.controls['DWT']?.invalid" class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['DWT']?.errors?.required">This
                                        Field is Required</span>
                                </div>
                                <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['DWT']?.invalid"
                                    class="red">
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['DWT']?.errors?.pattern">DWT
                                        must be (1 to 6) digits</span>
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['DWT']?.errors?.maxlength">This
                                        Field can be at most 50 characters</span>
                                </div>
                            </div>
                            <!-- SCNT -->
                            <div class="form-group">
                                <label for="txtSCNT">Net Tonnage (SCNT)</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <input type="text" formControlName="SCNT" name="SCNT" id="txtSCNT"
                                    class="form-control" />
                                <div *ngIf="isTabOneSubmitted &&
                                    circularRequestForm?.controls['TabOne']?.controls['SCNT']?.invalid" class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['SCNT']?.errors?.required">This
                                        Field is Required</span>
                                </div>
                                <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['SCNT']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['SCNT']?.errors?.pattern">Net
                                        Tonnage (SCNT) must be (1 to 6) digits and allows (1 to 2) Decimals</span>
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['SCNT']?.errors?.maxlength">This
                                        Field can be at most 50 characters</span>
                                </div>
                            </div>
                            <!-- Last Transit Date -->
                            <div class="form-group">
                                <label for="dpLastTransitDate">Last Transit Date</label>
                                <input #lastTransitDateDatepicker="bsDatepicker" bsDatepicker
                                    formControlName="LastTransitDate" [minDate]='null'
                                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', minMode: hour, maxDate: yearBuiltMaxDate}"
                                    autocomplete="off" id="dpLastTransitDate" class="form-control"
                                    name="LastTransitDate">
                            </div>
                            <div class="form-group">
                                <label for="BunkeringPort">Bunkering Port</label>
                                <input type="text" id="BunkeringPort" name="BunkeringPort"
                                    formControlName="BunkeringPort" class="form-control" />
                            </div>
                            <!-- Main Engine Fuel Type -->
                            <div class="form-group">
                                <label for="ddlMainEngineFuelId">Main Engine Fuel Type</label>
                                <select formControlName="MainEngineFuelId" class="form-control" id="ddlMainEngineFuelId"
                                    name="MainEngineFuel" (change)="onMainEngineFuelTypeChange($event.target.value)">
                                    <option value="" selected>Choose</option>
                                    <option *ngFor="let mainEngineFuel of mainEngineFuels" [value]="mainEngineFuel?.Id">
                                        {{mainEngineFuel?.Fuel}}
                                    </option>
                                    <option value="-1">Other</option>
                                </select>
                            </div>

                            <!-- Other (Main Engine Fuel Type) -->
                            <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['MainEngineFuelId'].value == -1"
                                class="form-group">
                                <label for="txtOtherMainEngineFuel">Other (Main Engine Fuel Type)</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <input type="text" formControlName="OtherMainEngineFuel" name="OtherMainEngineFuel"
                                    id="txtOtherMainEngineFuel" class="form-control" />
                                <div *ngIf="isTabOneSubmitted &&
                                    circularRequestForm?.controls['TabOne']?.controls['OtherMainEngineFuel']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['OtherMainEngineFuel']?.errors?.required">This
                                        Field is Required</span>
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Engine Type</label>
                                <div>
                                    <div class="custom-Radio">
                                        <input type="radio" formControlName="EngineType" id="rbtnIEngineTypeYes"
                                            value="true" />
                                        <label for="rbtnIEngineTypeYes">Eco</label>
                                    </div>
                                    <div class="custom-Radio">
                                        <input type="radio" formControlName="EngineType" id="rbtnIEngineTypeNo"
                                            value="false" />
                                        <label for="rbtnIEngineTypeNo">Non Eco</label>
                                    </div>
                                </div>

                            </div>
                            <!-- Scrubber Fitted -->
                            <div class="form-group">
                                <label>Scrubber Fitted</label>
                                <div>
                                    <div class="custom-Radio">
                                        <input type="radio" formControlName="IsScrubberFitted"
                                            id="rbtnIsScrubberFittedYes" value="true" />
                                        <label for="rbtnIsScrubberFittedYes">Yes</label>
                                    </div>
                                    <div class="custom-Radio">
                                        <input type="radio" formControlName="IsScrubberFitted"
                                            id="rbtnIsScrubberFittedNo" value="false" />
                                        <label for="rbtnIsScrubberFittedNo">No</label>
                                    </div>
                                </div>

                            </div>


                            <!-- Vessel Condition -->
                            <div class="form-group">
                                <label>Vessel's Condition</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <div>
                                    <div class="custom-Radio">
                                        <input type="radio" formControlName="IsShipLoaded" id="rbtnIsShipLoadedLaden"
                                            value="true" (change)="onVesselConditionChange($event.target.value)" />
                                        <label for="rbtnIsShipLoadedLaden">Loaded</label>
                                    </div>
                                    <div class="custom-Radio">
                                        <input type="radio" formControlName="IsShipLoaded" id="rbtnIsShipLoadedBallast"
                                            value="false" (change)="onVesselConditionChange($event.target.value)" />
                                        <label for="rbtnIsShipLoadedBallast">Ballast</label>
                                    </div>
                                </div>
                                <div *ngIf="isTabOneSubmitted &&
                                    circularRequestForm?.controls['TabOne']?.controls['IsShipLoaded']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['IsShipLoaded']?.errors?.required">This
                                        Field is Required</span>
                                </div>
                            </div>
                            <!-- Cargo Kind -->
                            <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['IsShipLoaded'].value == 'true'"
                                class="form-group">
                                <label for="txtCargoKind">Cargo Type</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <input type="text" formControlName="CargoKind" name="CargoKind" id="txtCargoKind"
                                    class="form-control" />
                                <div *ngIf="isTabOneSubmitted &&
                                    circularRequestForm?.controls['TabOne']?.controls['CargoKind']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['CargoKind']?.errors?.required">This
                                        Field is Required</span>
                                </div>
                                <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['CargoKind']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['CargoKind']?.errors?.pattern">Please
                                        Enter a Valid Cargo Kind Value</span>
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['CargoKind']?.errors?.maxlength">This
                                        Field can be at most 200 characters</span>
                                </div>
                            </div>
                            <!-- Cargo Quantity -->
                            <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['IsShipLoaded'].value == 'true'"
                                class="form-group">
                                <label for="txtCargoQuantity">Cargo Quantity (Ton)</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <input type="text" formControlName="CargoQuantity" name="CargoQuantity"
                                    id="txtCargoQuantity" maxlength="6" class="form-control"
                                    (input)="onCargoChange($event.target.value)" />

                                <div *ngIf="isTabOneSubmitted &&
                                    circularRequestForm?.controls['TabOne']?.controls['CargoQuantity']?.invalid"
                                    class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['CargoQuantity']?.errors?.required">This
                                        Field is Required</span>
                                </div>
                                <div *ngIf="showCargoWarning" style="color:darkgoldenrod;font-size:14px;">Cargo Quantity
                                    cannot be greater than DWT</div>
                                <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['CargoQuantity']?.invalid"
                                    class="red">
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['CargoQuantity']?.errors?.pattern">Cargo
                                        Quantity must be (1 to 6) digits</span>
                                    <span
                                        *ngIf="circularRequestForm?.controls['TabOne']?.controls['CargoQuantity']?.errors?.maxlength">This
                                        Field can be at most 200 characters</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="Notes">Notes</label>
                                <textarea name="Note" id="Note" name="Note" formControlName="Note"
                                    class="form-control"></textarea>
                            </div>
                            <!-- TPI / TPC -->
                            <!-- <div class="form-group">
                                <label for="txtTPITPC">TPI or TPC</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <input type="text" formControlName="TPITPC" name="TPITPC" id="txtTPITPC" class="form-control" />
                                <div *ngIf="isTabOneSubmitted && circularRequestForm?.controls['TabOne']?.controls['TPITPC']?.invalid" class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['TPITPC']?.errors?.required">This Field is Required</span>
                                </div>
                                <div *ngIf="circularRequestForm?.controls['TabOne']?.controls['TPITPC']?.invalid" class="red">
                                    <span *ngIf="circularRequestForm?.controls['TabOne']?.controls['TPITPC']?.errors?.maxlength">This Field can be at most 200 characters</span>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <!-- Next -->
                    <p *ngIf="formMode != 3" class="btns-holder text-right">
                        <button type="button" class="btn SCAcustomBtn" (click)="selectTab(2)">Next</button>
                    </p>
                </tab>
                <!-- Step Two -->
                <tab heading="Step Two">
                    <!-- Repeated Sections Container -->
                    <div formGroupName="TabTwo">
                        <!-- Options Grid -->
                        <div *ngIf="rebateRequestOptionsArrLength > 1 && isOptionsHeadersEnabled"
                            class="table-responsive">
                            <table class="table table-bordered table-striped table-services">
                                <thead>
                                    <tr>
                                        <!-- <th><span>Last Country of Origin</span></th> -->
                                        <th><span>Origin Region</span></th>
                                        <!-- <th><span>First Country of Destination</span></th> -->
                                        <th><span>Destination Region</span></th>
                                        <th *ngIf="formMode != 3"></th>
                                        <th *ngIf="formMode != 3"></th>
                                        <th *ngIf="formMode == 3"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                    *ngFor="let optionGridArr of circularRequestForm.controls['TabTwo'].value['Options']; let o = index;">
                                        <!-- Logical Container -->
                                        <ng-container
                                            *ngIf="(o != rebateRequestOptionsArrLength - 1) && !optionGridArr.IsOptionDeleted">
                                            <!-- <td>{{lastCountryOriginsArr[o].Text}}</td> -->
                                            <td> {{OriginsArr[o]?.Port}} -  {{OriginsArr[o]?.Text}}
                                            </td>
                                            <!-- <td>{{firstCountryDestinationsArr[o].Text}}</td> -->
                                            <td>{{distinationArr[o]?.Port}} - {{distinationArr[o]?.Text}}

                                            </td>
                                            <td *ngIf="formMode != 3"><a class="btn" (click)="editOption(o)">Edit</a>
                                            </td>
                                            <td *ngIf="formMode != 3"><a class="btn" Confirmation
                                                    (confirmationClick)="deleteOption(o)">Delete</a></td>
                                            <td *ngIf="formMode == 3"><a class="btn"
                                                    (click)="detailsOption(o)">Details</a></td>
                                        </ng-container>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- Voyage(s) Direction -->
                        <div class="form-container" #tabTwo>
                            <div class="form-section">
                                <h4 *ngIf="formMode != 3" class="section-title">Please Select Voyage(s) Direction</h4>
                                <h4 *ngIf="formMode == 3" class="section-title">Voyage(s) Direction</h4>
                                <!-- Direction -->
                                <div class="form-group">
                                    <label for="ddlDirectionId">Direction</label>
                                    <span *ngIf="formMode != 3 && !isCloneComponent" class="red"> *</span>
                                    <select (change)="onDirectionSelect($event.target.value)"
                                        formControlName="SailDirectionId" class="form-control" id="ddlDirectionId"
                                        name="Direction">
                                        <option value="" selected>Choose</option>
                                        <option *ngFor="let sailDirection of sailDirections"
                                            [value]="sailDirection?.Id">
                                            {{sailDirection?.Direction}}
                                        </option>
                                    </select>
                                    <div *ngIf="cannoteditOrigin">
                                        <span>
                                            You can't edit selected Direction, edit or delete added options first
                                        </span>
                                    </div>

                                    <div *ngIf="isTabTwoSubmitted &&
                                        circularRequestForm?.controls['TabTwo']?.controls['SailDirectionId']?.invalid"
                                        class="red">
                                        <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['SailDirectionId']?.errors?.required">This
                                            Field is Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                            <!-- Dates -->
                            <div class="form-container" #tabTwo>
                                <div class="form-section">
                                    <h4 *ngIf="formMode != 3" class="section-title">Voyage(s) Dates</h4>
                                    <h4 *ngIf="formMode == 3" class="section-title">Voyage(s) Dates</h4>
                                    <div class="form-group">
                                        <label for="dpDateOfSailing">Date of Sailing</label>
                                        <span *ngIf="formMode != 3" class="red"> *</span>
                                        <input #dateOfSailingDatepicker="bsDatepicker" bsDatepicker
                                            formControlName="DateOfSailing"
                                            [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', minMode: hour}"
                                            [minDate]='dateOfSailing' autocomplete="off" id="dpDateOfSailing"
                                            class="form-control" name="DateOfSailing"
                                            (ngModelChange)="dateOfSailingChange()">
                                        <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['DateOfSailing'].invalid"
                                            class="red">

                                            <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls[DateOfSailing]?.errors?.required">This
                                                Field is Required</span>
                                            <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['DateOfSailing']?.errors?.inValidSailingDateError">
                                                    {{'FRONT_USER.DATE_ERROR' | translate}}
            
                                                </span>
                                        </div>
                                        <div *ngIf="isDateOfSailingGTETA" class="red">
                                            <span>Date of Sailing shouldn't be after Estimated Time of Arrival
                                                (ETA)</span>
                                        </div>
                                    </div>


                                    <div class="form-group">
                                        <label for="ETASC">ETA Suez Canal</label>
                                        <span *ngIf="formMode != 3" class="red"> *</span>
                                        <input #ETASCDatepicker="bsDatepicker" bsDatepicker formControlName="ETASC"
                                            [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', minMode: hour}"
                                            autocomplete="off" id="ETASC" class="form-control" name="ETASC"
                                            (ngModelChange)="dateOfSailingChange()">
                                        <div *ngIf="
                                            circularRequestForm?.controls['TabTwo']?.controls['ETASC'].invalid"
                                            class="red">
                                            <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['ETASC'].errors?.required">This
                                                Field is Required</span>
                                            <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['ETASC']?.errors?.inValidDateError">
                                                    {{'FRONT_USER.DATE_ERROR' | translate}}
            
                                                </span>
                                        </div>
                                        <div *ngIf="isETASCGTETAD" class="red">
                                            <span>ETA Suez Canal shouldn't be after ETA Destination port</span>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="ETD">ETA Destination port</label>
                                        <span *ngIf="formMode != 3" class="red"> *</span>
                                        <input #ETADatepicker="bsDatepicker" bsDatepicker formControlName="ETD"
                                            [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', minMode: hour}"
                                            autocomplete="off" id="ETD" class="form-control" name="ETD"
                                            (ngModelChange)="dateOfSailingChange()">
                                            <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['ETD'].invalid"
                                            class="red">
                                            <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['ETD'].errors?.required">This
                                                Field is Required</span>
                                            <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['ETD']?.errors?.inValidDateError">
                                                    {{'FRONT_USER.DATE_ERROR' | translate}}
            
                                                </span>
                                        </div>

                                    </div>

                                </div>
                            </div>


                        <div class="form-container" #tabTwo>
                            <div class="form-section">
                                <h4 *ngIf="formMode != 3" class="section-title">Please Select Requested Circular</h4>
                                <h4 *ngIf="formMode == 3" class="section-title">Requested Circular</h4>
                                <div class="form-group">
                                    <label for="CircularsLookupId">Circular</label>
                                    <span *ngIf="formMode != 3 && !isCloneComponent" class="red"> *</span>
                                    <select (change)="onCircularLookupSelect($event.target.value)"
                                        formControlName="CircularsLookupId" class="form-control" id="CircularsLookupId"
                                        name="CircularsLookupId">
                                        <option value="" selected>Choose</option>
                                        <option *ngFor="let circular of circulars" [value]="circular?.Id">
                                            {{circular?.CircularNo}} - {{circular?.Symbol}}
                                        </option>
                                    </select>
                                    <div *ngIf="cannoteditOrigin">
                                        <span>
                                            You can't edit selected Circular,edit or delete added options first
                                        </span>
                                    </div>
                                    <div *ngIf="isTabTwoSubmitted &&
                                        circularRequestForm?.controls['TabTwo']?.controls['CircularsLookupId']?.invalid"
                                        class="red">
                                        <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['CircularsLookupId']?.errors?.required">This
                                            Field is Required</span>
                                    </div>
                                    <div *ngIf="showURL">
                                        <label for="CircularsLookupId">
                                            <a (click)="goToCircularDetails()" target="_blank">Circular Details
                                            </a>
                                        </label>
                                    </div>
                                </div>

                               <!-- <div class="form-group" *ngIf="formMode == 3">-->
                                  <div class="form-group" *ngIf="formMode == 3">
                                    <label for="OriginRegionId">Origin Region</label>

                                    <select (change)="onOriginSelect($event.target.value)" disabled
                                        formControlName="OriginRegionId" class="form-control" id="OriginRegionId"
                                        name="OriginRegionId">

                                        <option *ngFor="let Region of FromRegions" [value]="Region?.FromRegionId">
                                            {{Region?.CircularsRegions.NameEN}}
                                        </option>
                                    </select>
                                    <div *ngIf="isTabTwoSubmitted &&
                                        circularRequestForm?.controls['TabTwo']?.controls['OriginRegionId']?.invalid"
                                        class="red">
                                        <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['OriginRegionId']?.errors?.required">This
                                            Field is Required</span>
                                    </div>

                                </div>
                                <div class="form-group" *ngIf="formMode == 2">
                                    <label for="OriginRegionId">Origin Region</label>
                                    <span *ngIf="formMode != 3 && !isCloneComponent" class="red"> *</span>
                                    <select (change)="onOriginSelect($event.target.value)" disabled
                                        formControlName="OriginRegionId" class="form-control" id="OriginRegionId"
                                        name="OriginRegionId">
                                        <option value="" selected>Choose</option>
                                        <option *ngFor="let Region of FromRegions" [value]="Region?.FromRegionId">
                                            {{Region?.CircularsRegions.NameEN}}
                                        </option>
                                    </select>
                                    <div *ngIf="OriginshowDescription">
                                        <span style="font-weight: bold;">
                                            {{originDescription}}
                                        </span>
                                    </div>
                                    <div *ngIf="cannoteditOrigin">
                                        <span>
                                            You can't edit Origin Region,edit or delete added options first
                                        </span>
                                    </div>
                                    <div *ngIf="NoData" class="red">
                                        <span>
                                            no regions available for selected Circular in this direction
                                        </span>
                                    </div>
                                    <div *ngIf="isTabTwoSubmitted &&
                                        circularRequestForm?.controls['TabTwo']?.controls['OriginRegionId']?.invalid"
                                        class="red">
                                        <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['OriginRegionId']?.errors?.required">This
                                            Field is Required</span>
                                    </div>

                                </div>

                                <div class="form-group" *ngIf="formMode == 1">
                                    <label for="OriginRegionId">Origin Region</label>
                                    <span *ngIf="formMode != 3 && !isCloneComponent" class="red"> *</span>
                                    <select (change)="onOriginSelect($event.target.value)" disabled
                                        formControlName="OriginRegionId" class="form-control" id="OriginRegionId"
                                        name="OriginRegionId">
                                        <option value="" selected>Choose</option>
                                        <option *ngFor="let Region of FromRegions" [value]="Region?.FromRegionId">
                                            {{Region?.CircularsRegions.NameEN}}
                                        </option>
                                    </select>
                                    <div *ngIf="OriginshowDescription">
                                        <span style="font-weight: bold;">
                                            {{originDescription}}
                                        </span>
                                    </div>
                                    <div *ngIf="cannoteditOrigin">
                                        <span>
                                            You can't edit Origin Region, edit or delete added options first
                                        </span>
                                    </div>
                                    <div *ngIf="NoData" class="red">
                                        <span>
                                            no regions available for selected Circular in this direction
                                        </span>
                                    </div>
                                    <div *ngIf="isTabTwoSubmitted &&
                                        circularRequestForm?.controls['TabTwo']?.controls['OriginRegionId']?.invalid"
                                        class="red">
                                        <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['OriginRegionId']?.errors?.required">This
                                            Field is Required</span>

                                    </div>

                                </div>

                            </div>
                        </div>

                        <div formArrayName="Options"
                            *ngFor="let option of circularRequestForm.controls['TabTwo'].get('Options')['controls']; let i = index;">
                            <div *ngIf="i === rebateRequestOptionsArrLength - 1 && showOptionDev" [formGroupName]="i">
                                <div class="form-container" #options>
                                    <!-- Voyage Info. Section -->
                                    <div class="form-section">
                                        <!-- Options Array Validation Message -->
                                        <h5 class="red"  *ngIf="isFormSubmitted && !isOptionsArrValid">Rebate Request
                                            should
                                            contains One Voyage at least</h5>
                                        <h4 class="section-title">Voyage Information</h4>


                                        <div class="form-group">
                                            <label for="ddlLastCountryOriginId">Last Country of Origin</label>
                                            <span *ngIf="formMode != 3" class="red"> *</span>
                                            <select formControlName="LastCountryOriginId" class="form-control"
                                                (change)="onLastCountrySelect($event.target.value)"
                                                id="ddlLastCountryOriginId" name="LastCountryOrigin">
                                                <option value="" selected>Choose</option>
                                                <option *ngFor="let country of countries" [value]="country?.Id">
                                                    {{country?.NameEN}}
                                                </option>
                                            </select>
                                            <div *ngIf="isOptionSubmitted &&
                                                circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.LastCountryOriginId?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.LastCountryOriginId?.errors?.required">This
                                                    Field is Required</span>
                                            </div>
                                        </div>
                                        <!-- Last Port of Origin -->
                                        <div class="form-group">
                                            <label for="ddlLastPortOriginId">Last Port of Origin</label>
                                            <span *ngIf="formMode != 3" class="red"> *</span>
                                            <select formControlName="LastPortOriginId" class="form-control"
                                                id="ddlLastPortOriginId" name="LastPortOrigin"
                                                (change)="onLastPortSelect($event.target.value)">
                                                <option value="" selected>Choose</option>
                                                <option *ngFor="let lastPortOrigin of lastPortsOrigin"
                                                    [value]="lastPortOrigin?.Id">
                                                    {{lastPortOrigin?.NameEN}}
                                                </option>
                                                <option value="-1">Other</option>
                                            </select>
                                            <div *ngIf="isOptionSubmitted &&
                                                circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.LastPortOriginId?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.LastPortOriginId?.errors?.required">This
                                                    Field is Required</span>
                                            </div>
                                        </div>
                                        <!-- Other (Last Port of Origin) -->
                                        <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.LastPortOriginId?.value == -1"
                                            class="form-group">
                                            <label for="txtOtherLastPortOrigin">Other (Last Port of Origin)</label>
                                            <span *ngIf="formMode != 3" class="red"> *</span>
                                            <input type="text" formControlName="OtherLastPortOrigin"
                                                name="OtherLastPortOrigin" id="txtOtherLastPortOrigin"
                                                class="form-control" />
                                            <div *ngIf="isOptionSubmitted &&
                                                circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.OtherLastPortOrigin?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.OtherLastPortOrigin?.errors?.required">This
                                                    Field is Required</span>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="CircularsPercentagesId">Destination Region</label>
                                            <span *ngIf="formMode != 3" class="red"> *</span>
                                            <select (change)="ondistSelect($event.target.value)"
                                                formControlName="CircularsPercentagesId" class="form-control"
                                                id="CircularsPercentagesId" name="CircularsPercentagesId">
                                                <option value="" selected>Choose</option>
                                                <option *ngFor="let Region of ToRegions" [value]="Region?.Id">
                                                    {{Region?.CircularsRegions1.NameEN}}
                                                </option>
                                            </select>
                                            <div *ngIf="DistshowDescription">
                                                <span style="font-weight: bold;">
                                                    {{distDescription}}
                                                </span>
                                            </div>
                                            <div *ngIf="DistDuplicate">
                                                <span class="red">
                                                    Duplicate origin and destination regions
                                                </span>
                                            </div>
                                            <div *ngIf="isOptionSubmitted &&
                                                circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CircularsPercentagesId?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CircularsPercentagesId?.errors?.required">This
                                                    Field is Required</span>
                                            </div>

                                        </div>
                                        <!-- First Country of Destination -->
                                        <div class="form-group">
                                            <label for="ddlFirstCountryDestinationId">First Country of
                                                Destination</label>
                                            <select formControlName="FirstCountryDestinationId" class="form-control"
                                                (change)="onFirstCountrySelect($event.target.value)"
                                                id="ddlFirstCountryDestinationId" name="FirstCountryDestination">
                                                <option value="" selected>Choose</option>
                                                <option *ngFor="let country of countries" [value]="country?.Id">
                                                    {{country?.NameEN}}
                                                </option>
                                            </select>

                                        </div>
                                        <!-- First Port of Destination -->
                                        <div class="form-group">
                                            <label for="ddlFirstPortDestinationId">First Port of Destination</label>
                                            <select formControlName="FirstPortDestinationId" class="form-control"
                                                id="ddlFirstPortDestinationId" name="FirstPortDestination"
                                                (change)="onFirstPortSelect($event.target.value)">
                                                <option value="" selected>Choose</option>
                                                <option *ngFor="let firstPortDestination of firstPortsDestination"
                                                    [value]="firstPortDestination?.Id">
                                                    {{firstPortDestination?.NameEN}}
                                                </option>
                                                <option value="-1">Other</option>
                                            </select>

                                        </div>
                                        <!-- Other (First Port of Destination) -->
                                        <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.FirstPortDestinationId?.value == -1"
                                            class="form-group">
                                            <label for="txtOtherFirstPortDestination">Other (First Port of
                                                Destination)</label>
                                            <span *ngIf="formMode != 3" class="red"> *</span>
                                            <input type="text" formControlName="OtherFirstPortDestination"
                                                name="OtherFirstPortDestination" id="txtOtherFirstPortDestination"
                                                class="form-control" />
                                            <div *ngIf="isOptionSubmitted &&
                                                circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.OtherFirstPortDestination?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.OtherFirstPortDestination?.errors?.required">This
                                                    Field is Required</span>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="txtActualSpeed">Actual Speed (NM)</label>

                                            <input type="text" formControlName="ActualSpeed" name="ActualSpeed"
                                                id="txtActualSpeed" maxlength="5" class="form-control" />
                                            <div *ngIf="isOptionSubmitted &&
                                                circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ActualSpeed?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ActualSpeed?.errors?.required">This
                                                    Field is Required</span>
                                            </div>
                                            <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ActualSpeed?.invalid"
                                                class="red">
                                                <span
                                                    *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ActualSpeed?.errors?.pattern">Actual
                                                    Speed must be (1 to 2) digits and allows (1 to 2) Decimals</span>
                                                <span
                                                    *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ActualSpeed?.errors?.maxlength">This
                                                    Field can be at most 50 characters</span>
                                            </div>
                                        </div>



                                        <!-- Cost Section -->
                                        <div class="form-section">
                                            <h4 class="section-title">Voyage Cost</h4>

                                            <!-- Daily Bunker Consumption IFO/Ton -->
                                            <div class="form-group">
                                                <label for="txtIFOTon">Daily Bunker Consumption (IFO) in Ton</label>
                                                <input type="text" formControlName="IFOTon" name="IFOTon" id="txtIFOTon"
                                                    maxlength="4" class="form-control" />
                                                <div *ngIf="isOptionSubmitted &&
                                                    circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.invalid"
                                                    class="red">
                                                    <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.errors?.required">This
                                                        Field is Required</span>
                                                </div>
                                                <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.invalid"
                                                    class="red">
                                                    <!-- <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.errors?.pattern">This Field allows digits only</span> -->
                                                    <span
                                                        *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.errors?.pattern">This
                                                        Field must be (1 to 2) digits and allows (1) Decimal</span>
                                                    <span
                                                        *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.errors?.maxlength">This
                                                        Field can be at most 50 characters</span>
                                                </div>
                                            </div>
                                            <!-- Daily Bunker Price IFO ($/ton) -->
                                            <div class="form-group">
                                                <label for="txtIFOTonPrice">Bunker Price (IFO) ($/ton)</label>
                                                <input type="text" formControlName="IFOTonPrice" name="IFOTonPrice"
                                                    id="txtIFOTonPrice" class="form-control" />
                                                <div *ngIf="isOptionSubmitted &&
                                                    circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.invalid"
                                                    class="red">
                                                    <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.errors?.required">This
                                                        Field is Required</span>
                                                </div>
                                                <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.invalid"
                                                    class="red">
                                                    <span
                                                        *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.errors?.pattern">This
                                                        Field must be (1 to 4) digits and allows (2) Decimal</span>
                                                    <!-- <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.errors?.pattern">This Field must be (1 to 2) digits and allows (1) Decimal</span> -->
                                                    <span
                                                        *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.errors?.maxlength">This
                                                        Field can be at most 200 characters</span>
                                                </div>
                                            </div>
                                            <!-- Daily Bunker Consumption DO/Ton -->
                                            <div class="form-group">
                                                <label for="txtDOTon">Daily Bunker Consumption (DO) in Ton</label>
                                                <input type="text" formControlName="DOTon" name="DOTon" id="txtDOTon"
                                                    maxlength="4" class="form-control" />
                                                <div *ngIf="isOptionSubmitted &&
                                                    circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.invalid"
                                                    class="red">
                                                    <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.errors?.required">This
                                                        Field is Required</span>
                                                </div>
                                                <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.invalid"
                                                    class="red">
                                                    <!-- <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.errors?.pattern">This Field allows digits only</span> -->
                                                    <span
                                                        *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.errors?.pattern">This
                                                        Field must be (1 to 2) digits and allows (1) Decimal</span>
                                                    <span
                                                        *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.errors?.maxlength">This
                                                        Field can be at most 50 characters</span>
                                                </div>
                                            </div>
                                            <!-- Daily Bunker Price DO ($/ton) -->
                                            <div class="form-group">
                                                <label for="txtDOTonPrice">Bunker Price (DO) ($/ton)</label>

                                                <input type="text" formControlName="DOTonPrice" name="DOTonPrice"
                                                    id="txtDOTonPrice" class="form-control" />
                                                <div *ngIf="isOptionSubmitted &&
                                                    circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.invalid"
                                                    class="red">
                                                    <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.errors?.required">This
                                                        Field is Required</span>
                                                </div>
                                                <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.invalid"
                                                    class="red">
                                                    <span
                                                        *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.errors?.pattern">This
                                                        Field must be (1 to 4) digits and allows (2) Decimal</span>
                                                    <!-- <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.errors?.pattern">This Field must be (1 to 2) digits and allows (1) Decimal</span> -->
                                                    <span
                                                        *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.errors?.maxlength">This
                                                        Field can be at most 200 characters</span>
                                                </div>
                                            </div>


                                        </div>


                                        <!--<div class="form-group">
                                            <label for="RebateNotes">Notes</label>
                                            <textarea  name="RebateNote" id="RebateNote" formControlName="ETA" class="form-control"></textarea>
                                        </div>-->
                                    </div>
                                    <!-- Bunkering Ports Section -->
                                    <!-- <div class="form-section">
                                        <h4 class="section-title">Bunkering Ports</h4>
                                    </div> -->
                                </div>
                                <!-- Add New Voyage -->
                                <div *ngIf="(rebateRequestOptionsArrLength - noOfOptionsToBeDeletedGlobal) == 1"
                                    class="bs-callout bs-callout-info" style="margin: 15px;">
                                    <h4>Please Note</h4>
                                    <p>You must add at least One Voyage</p>
                                </div>
                                <p *ngIf="!isOptionEdited && formMode != 3 && !DistDuplicate" class="btns-holder">
                                    <button type="button" class="btn SCAcustomBtn" (click)="addNewVoyage()">Save
                                        Voyage</button>
                                </p>
                                <p *ngIf="isOptionEdited && !DistDuplicate" class="btns-holder">
                                    <!-- Save -->
                                    <button type="button" class="btn SCAcustomBtn"
                                        (click)="saveEditedVoyage()">Save</button>
                                </p>
                                <p *ngIf="DistDuplicate" class="btns-holder">
                                    <button type="button" class="btn SCAcustomBtn"
                                        (click)="cancelEditVoyage()">Cancel</button>
                                </p>
                            </div>
                        </div>
                        <!-- Principal Section -->
                        <div>
                            <div #tabTwoPrincipal>
                                <div class="form-container">
                                    <div class="form-section">
                                        <h4 class="section-title">Principal</h4>
                                        <!-- Name -->
                                        <div class="form-group">
                                            <label for="txtName">Name</label>
                                            <span *ngIf="formMode != 3" class="red"> *</span>
                                            <input type="email" formControlName="Name" name="Name" id="txtName"
                                                class="form-control text-uppercase" />
                                            <div *ngIf="isTabTwoSubmitted &&
                                                circularRequestForm?.controls['TabTwo']?.controls['Name']?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Name']?.errors?.required">This
                                                    Field is Required</span>
                                            </div>
                                            <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Name']?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Name']?.errors?.pattern">Please
                                                    Enter a Valid Name</span>
                                                <span
                                                    *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Name']?.errors?.maxlength">This
                                                    Field can be at most 200 characters</span>
                                            </div>
                                        </div>
                                        <!-- Email -->
                                        <div class="form-group">
                                            <label for="txtEMail">Email</label>
                                            <span *ngIf="formMode != 3" class="red"> *</span>
                                            <input type="text" formControlName="EMail" name="EMail" id="txtEMail"
                                                class="form-control" />
                                            <div *ngIf="isTabTwoSubmitted &&
                                                circularRequestForm?.controls['TabTwo']?.controls['EMail']?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['EMail']?.errors?.required">This
                                                    Field is Required</span>
                                            </div>
                                            <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['EMail']?.invalid"
                                                class="red">
                                                <!-- <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['EMail']?.errors?.email">Please Enter a Valid Email Format</span> -->
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['EMail']?.errors?.pattern">Please
                                                    Enter a Valid Email Format</span>
                                                <span
                                                    *ngIf="circularRequestForm?.controls['TabTwo']?.controls['EMail']?.errors?.maxlength">This
                                                    Field can be at most 50 characters</span>
                                            </div>
                                        </div>
                                        <!-- Fax -->
                                        <div class="form-group">
                                            <label for="txtFax">Fax</label>
                                            <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                                            <input type="text" formControlName="Fax" name="Fax" id="txtFax"
                                                class="form-control" />
                                            <!-- <div *ngIf="isTabTwoSubmitted && circularRequestForm?.controls['TabTwo']?.controls['Fax']?.invalid" class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Fax']?.errors?.required">This Field is Required</span>
                                            </div> -->
                                            <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Fax']?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['Fax']?.errors?.pattern">Please
                                                    Enter a Valid Fax Number</span>
                                            </div>
                                        </div>
                                        <!-- Terms & Conditions -->
                                        <div *ngIf="formMode == 1 || (formMode == 2 && !editModeAdmin) || isCloneComponent || (formMode == 2 && isRequestDetailsComponent)"
                                            class="form-group">
                                            <label for="chkTermsConditions">Terms & Conditions</label>
                                            <span class="red"> *</span>
                                            <div class="custom-checkbox">
                                                <input type="checkbox" formControlName="TermsConditions"
                                                    name="TermsConditions" id="chkTermsConditions"
                                                    [checked]="TermsConditions">
                                                <label for="chkTermsConditions">
                                                    <a (click)="goToTermsAndConditions()" target="_blank">I accept terms
                                                        &
                                                        Conditions</a>
                                                </label>
                                            </div>
                                            <div *ngIf="isTabTwoSubmitted &&
                                                circularRequestForm?.controls['TabTwo']?.controls['TermsConditions']?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['TermsConditions']?.errors?.pattern">You
                                                    should accept Service Terms & Conditions to use this Service</span>
                                            </div>
                                        </div>
                                        <!-- reCaptcha -->
                                        <!-- <div *ngIf="formMode == 1 || (formMode == 2 && !editModeAdmin)" id="divRecaptcha" class="form-group">
                                            <label for="reCaptcha">Captcha</label>
                                            <span class="red"> *</span>
                                            <ngx-recaptcha2 #reCaptcha formControlName="recaptcha" [siteKey]="sitekey" useGlobalDomain="false"></ngx-recaptcha2>
                                            <div *ngIf="isTabTwoSubmitted && circularRequestForm?.controls['TabTwo']?.controls['recaptcha']?.invalid" class="red ">
                                                <div *ngIf="circularRequestForm?.controls['TabTwo']?.controls['recaptcha']?.errors?.required">
                                                    <span>Captcha is Required</span>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Previous -->
                    <p *ngIf="formMode != 3" class="btns-holder text-right">
                        <button type="button" class="btn SCAcustomBtn" (click)="selectTab(1)">Previous</button>
                    </p>
                </tab>
            </tabset>
            <div class="form-group" *ngIf="showSubmit">
                <button
                    *ngIf="(((isTabOneValid && formMode == 1) || formMode == 2) && !editModeAdmin) || isCloneComponent || (formMode == 2 && isRequestDetailsComponent)"
                    type="button" class="btn SCAcustomBtn" (click)="submit()">Submit</button>
            </div>
        </form>
    </div>

    <div class="read-only-content" *ngIf="currentUser?.IsAdmin">

        <div class="form-container">
            <h4 class="section-title">Print Request Details</h4>
            <div class="form-group">
                <div>
                    <a class="export-link" href="#" (click)="exportcover($event)">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            aria-hidden="true" role="img" width="1.25em" height="1.25em"
                            preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
                            <path
                                d="M13.156 9.211c-.213-.21-.686-.321-1.406-.331a11.754 11.754 0 0 0-1.69.124c-.276-.159-.561-.333-.784-.542c-.601-.561-1.103-1.34-1.415-2.197c.02-.08.038-.15.054-.222c0 0 .339-1.923.249-2.573a.73.73 0 0 0-.044-.184l-.029-.076c-.092-.212-.273-.437-.556-.425l-.171-.005c-.316 0-.573.161-.64.403c-.205.757.007 1.889.39 3.355l-.098.239c-.275.67-.619 1.345-.923 1.94l-.04.077c-.32.626-.61 1.157-.873 1.607l-.271.144c-.02.01-.485.257-.594.323c-.926.553-1.539 1.18-1.641 1.678c-.032.159-.008.362.156.456l.263.132a.792.792 0 0 0 .357.086c.659 0 1.425-.821 2.48-2.662a24.79 24.79 0 0 1 3.819-.908c.926.521 2.065.883 2.783.883c.128 0 .238-.012.327-.036a.558.558 0 0 0 .325-.222c.139-.21.168-.499.13-.795a.531.531 0 0 0-.157-.271zM3.307 12.72c.12-.329.596-.979 1.3-1.556c.044-.036.153-.138.253-.233c-.736 1.174-1.229 1.642-1.553 1.788zm4.169-9.6c.212 0 .333.534.343 1.035s-.107.853-.252 1.113c-.12-.385-.179-.992-.179-1.389c0 0-.009-.759.088-.759zM6.232 9.961c.148-.264.301-.543.458-.839c.383-.724.624-1.29.804-1.755a5.813 5.813 0 0 0 1.328 1.649c.065.055.135.111.207.166c-1.066.211-1.987.467-2.798.779zm6.72-.06c-.065.041-.251.064-.37.064c-.386 0-.864-.176-1.533-.464c.257-.019.493-.029.705-.029c.387 0 .502-.002.88.095s.383.293.318.333z"
                                fill="currentColor" />
                            <path
                                d="M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 0 1-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 0 0 .5.5H14v9.75z"
                                fill="currentColor" />
                        </svg>
                        <span>Print File Cover</span>
                    </a>
                </div>
            </div>

            <div class="form-group">
              <div>
                  <a class="export-link" href="#" (click)="exportFax($event)">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                          aria-hidden="true" role="img" width="1.25em" height="1.25em"
                          preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
                          <path
                              d="M13.156 9.211c-.213-.21-.686-.321-1.406-.331a11.754 11.754 0 0 0-1.69.124c-.276-.159-.561-.333-.784-.542c-.601-.561-1.103-1.34-1.415-2.197c.02-.08.038-.15.054-.222c0 0 .339-1.923.249-2.573a.73.73 0 0 0-.044-.184l-.029-.076c-.092-.212-.273-.437-.556-.425l-.171-.005c-.316 0-.573.161-.64.403c-.205.757.007 1.889.39 3.355l-.098.239c-.275.67-.619 1.345-.923 1.94l-.04.077c-.32.626-.61 1.157-.873 1.607l-.271.144c-.02.01-.485.257-.594.323c-.926.553-1.539 1.18-1.641 1.678c-.032.159-.008.362.156.456l.263.132a.792.792 0 0 0 .357.086c.659 0 1.425-.821 2.48-2.662a24.79 24.79 0 0 1 3.819-.908c.926.521 2.065.883 2.783.883c.128 0 .238-.012.327-.036a.558.558 0 0 0 .325-.222c.139-.21.168-.499.13-.795a.531.531 0 0 0-.157-.271zM3.307 12.72c.12-.329.596-.979 1.3-1.556c.044-.036.153-.138.253-.233c-.736 1.174-1.229 1.642-1.553 1.788zm4.169-9.6c.212 0 .333.534.343 1.035s-.107.853-.252 1.113c-.12-.385-.179-.992-.179-1.389c0 0-.009-.759.088-.759zM6.232 9.961c.148-.264.301-.543.458-.839c.383-.724.624-1.29.804-1.755a5.813 5.813 0 0 0 1.328 1.649c.065.055.135.111.207.166c-1.066.211-1.987.467-2.798.779zm6.72-.06c-.065.041-.251.064-.37.064c-.386 0-.864-.176-1.533-.464c.257-.019.493-.029.705-.029c.387 0 .502-.002.88.095s.383.293.318.333z"
                              fill="currentColor" />
                          <path
                              d="M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 0 1-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 0 0 .5.5H14v9.75z"
                              fill="currentColor" />
                      </svg>
                      <span>MEMO</span>
                  </a>
              </div>
          </div>
        </div>
    </div>
</div>
<!--<div class="form-container">
    <div *ngIf="!currentUser.IsAdmin && rebateRequestLoaded.CanClone && showClone">
        <h4 class="section-title">Actions</h4>

        <div>
            <div class="dropdown">
                <button id="request-action-menu" type="button" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    Actions List<span class="caret"></span>
                </button>
                <ul class="dropdown-menu" aria-labelledby="request-action-menu">
                    <li>
                        <button type="button" class="" (click)="navigateToCloneRequest()">Clone Request</button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>-->
<!-- Confirmation - Submit New Request -->
<div *ngIf="isFormValid && submitConfirmationMode == 1" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path
                        d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
                    </path>
                </g>
            </g>
        </svg>
        <p>{{confirmationMessage}}</p>
        <p *ngIf="formMode == 1 || isCloneComponent">Request Number [{{submitRebateRequestResponseObject.Data}}]</p>
        <p>Go Back to <a routerLink="/NavigationRequests">My Requests</a></p>
    </div>
</div>
<!-- Error -->
<div *ngIf="isFormValid && submitConfirmationMode == 2" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>Something went wrong, Please <a (click)="reloadComponent()">try again</a></p>
        <hr>
        <p>Go to <a href="/English/Pages/ContactUs.aspx">Contact Us</a></p>
    </div>
</div>
<app-messaging *ngIf="!isFormValid"></app-messaging>
